(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-mega-menu"] && !Shopify.designMode) return;
  try {
    const root = document.documentElement;
  const header = document.querySelector('.section-header');
  const desktopMq = window.matchMedia('(min-width: 1170px)');

  const updateHeaderBottom = () => {
    if (!header) return;
    const rect = header.getBoundingClientRect();
    root.style.setProperty('--mp-header-bottom', `${Math.max(0, rect.bottom)}px`);
    root.style.setProperty('--header-height', `${Math.max(0, rect.height)}px`);
  };

  let raf = 0;
  const schedule = () => {
    if (raf) return;
    raf = window.requestAnimationFrame(() => {
      raf = 0;
      updateHeaderBottom();
    });
  };

  updateHeaderBottom();
  window.addEventListener('resize', schedule, { passive: true });
  // Intentionally not updating on scroll: the panel should stay pinned.

  const portalPanelToBody = (details) => {
    const panel = details?.querySelector?.('.mp-mega__panel');
    if (!panel) return;
    if (panel.dataset.mpPortaled === '1') return;
    const placeholder = document.createElement('span');
    placeholder.dataset.mpMegaPanelPlaceholder = '1';
    panel.before(placeholder);
    document.body.appendChild(panel);
    panel.dataset.mpPortaled = '1';
  };

  const restorePanelFromBody = (details) => {
    const panel = document.querySelector('.mp-mega__panel[data-mp-portaled="1"]');
    if (!panel) return;
    const placeholder = details?.querySelector?.('[data-mp-mega-panel-placeholder="1"]');
    if (!placeholder) return;
    placeholder.before(panel);
    placeholder.remove();
    panel.dataset.mpPortaled = '0';
  };

  // Desktop: open mega menus on hover/focus (not click).
  const bindHoverOpen = () => {
    document.querySelectorAll('.mp-mega__details').forEach((details) => {
      if (details.dataset.mpHoverBound === '1') return;
      details.dataset.mpHoverBound = '1';
      let closeTimer = 0;

      const openSelf = () => {
        if (!desktopMq.matches) return;
        if (details.open) return;
        if (closeTimer) window.clearTimeout(closeTimer);

        // Close header predictive search when user moves to the menu.
        const headerPredictive = document.querySelector('.section-header predictive-search[open], .section-header predictive-search[loading]');
        if (headerPredictive && typeof headerPredictive.close === 'function') headerPredictive.close(false);
        const headerSearchInput = document.querySelector('.section-header #Search-In-Header-Desktop');
        headerSearchInput?.blur?.();

        details.open = true;
        portalPanelToBody(details);
        schedule();
        document.querySelectorAll('.mp-mega__details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      };

      const closeSelf = () => {
        if (!desktopMq.matches) return;
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          // Don't close if pointer moved into the portaled panel.
          const panel = document.querySelector('.mp-mega__panel[data-mp-portaled="1"]');
          if (panel && panel.matches(':hover')) return;
          details.open = false;
          restorePanelFromBody(details);
        }, 80);
      };

      details.addEventListener('mouseenter', openSelf);
      details.addEventListener('focusin', openSelf);
      details.addEventListener('mouseleave', (event) => {
        const panel = document.querySelector('.mp-mega__panel[data-mp-portaled="1"]');
        // If leaving details into the panel, keep it open.
        if (panel && event.relatedTarget && panel.contains(event.relatedTarget)) return;
        closeSelf();
      });

      // Keep open while hovering the panel; close when leaving it (unless moving back into details).
      document.addEventListener(
        'mouseenter',
        (event) => {
          const panel = event.target;
          if (!(panel instanceof HTMLElement)) return;
          if (!panel.classList.contains('mp-mega__panel')) return;
          if (closeTimer) window.clearTimeout(closeTimer);
        },
        true
      );
      document.addEventListener(
        'mouseleave',
        (event) => {
          const panel = event.target;
          if (!(panel instanceof HTMLElement)) return;
          if (!panel.classList.contains('mp-mega__panel')) return;
          // If leaving panel into its owning details, keep it open.
          if (event.relatedTarget && details.contains(event.relatedTarget)) return;
          closeSelf();
        },
        true
      );
    });
  };

  bindHoverOpen();

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.classList.contains('mp-mega__details')) return;
    if (details.open) {
      if (desktopMq.matches) portalPanelToBody(details);
      schedule();
      document.querySelectorAll('.mp-mega__details[open]').forEach((other) => {
        if (other !== details) other.open = false;
      });
    } else {
      restorePanelFromBody(details);
    }
  });

  const closeOpenMega = () => {
    const open = document.querySelector('.mp-mega__details[open]');
    if (!open) return;
    open.open = false;
    restorePanelFromBody(open);
  };

  document.querySelector('[data-mp-mega-backdrop]')?.addEventListener('click', () => {
    if (!desktopMq.matches) return;
    closeOpenMega();
  });

  document.addEventListener('click', (event) => {
    const open = document.querySelector('.mp-mega__details[open]');
    if (!open) return;
    if (open.contains(event.target)) return;
    const panel = document.querySelector('.mp-mega__panel[data-mp-portaled="1"]');
    if (panel?.contains(event.target)) return;
    closeOpenMega();
  }, { capture: true });
  } catch(e) { console.error(e); }
})();

})();
